import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@bufferapp/ui/Tooltip'
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark'
import PencilIcon from '@bufferapp/ui/Icon/Icons/Pencil'

import { Button } from './CommentToggle.styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'pending' implicitly has an 'any' ... Remove this comment to see the full error message
const CommentToggle = ({ pending, onClick }) => {
  let label = null
  let hotkey = null
  let testId = null

  if (pending) {
    label = 'Dismiss Comment'
    hotkey = 'CTRL + D'
    testId = 'dismiss-button'
  } else {
    label = 'Open and Reply'
    testId = 'undismiss-button'
  }

  const Icon = pending ? CheckmarkIcon : PencilIcon

  return (
    <>
      <Tooltip label={label} hotkey={hotkey} position="top">
        <Button onClick={onClick} data-testid={testId} aria-label={label}>
          <Icon size="medium" aria-hidden="true" />
        </Button>
      </Tooltip>
    </>
  )
}

CommentToggle.propTypes = {
  pending: PropTypes.bool,
  onClick: PropTypes.func,
}

CommentToggle.defaultProps = {
  pending: false,
  onClick: null,
}

export default CommentToggle
